module.exports = `
... on Video {
    title
    videoLink
    autoplay
    styles
}
`;
